export default __webpack_public_path__ + "static/media/bogsneak.7e6ea747.png";